import Immutable from 'seamless-immutable'
import _ from 'lodash'

import { CHOOSE_SUGGESTION, RECEIVE_COMPLETIONS } from 'reduxBits/searchInput/actionNames'
import * as autocompleteActions from 'reduxBits/autocomplete/actions'

const initialState = Immutable.from({
  predictiveSearch: {
    chosenSuggestion: null,
    suggestions: null,
    chosenHistory: null,
  },
})

const tracking = (state = initialState, { type, payload }) => {
  switch (type) {
    // When we change the location away from LI we reset the predictive search state
    // beacuse then if we get back to LI we don't want to have the
    // predicitve search data for the pageview
    case '@@router/LOCATION_CHANGE':
      if (!_.get(payload, 'location.pathname', '').startsWith('/annonser')) {
        return state.set('predictiveSearch', initialState.predictiveSearch)
      }

      return state

    case autocompleteActions.CHOOSE_SUGGESTION:
    // fallthrough
    case CHOOSE_SUGGESTION: {
      const isHistorySuggestion = !!payload.history
      if (isHistorySuggestion) {
        return state
          .setIn(['predictiveSearch', 'chosenHistory'], payload)
          .setIn(['predictiveSearch', 'chosenSuggestion'], null)
          .setIn(['predictiveSearch', 'suggestions'], null)
      }
      return state
        .setIn(['predictiveSearch', 'chosenSuggestion'], payload)
        .setIn(['predictiveSearch', 'chosenHistory'], null)
    }

    case autocompleteActions.RECEIVE_COMPLETIONS:
    // fallthrough
    case RECEIVE_COMPLETIONS:
      return state.setIn(['predictiveSearch', 'suggestions'], payload)

    default:
      return state
  }
}

export default tracking
